module.exports = __webpack_public_path__ + "img/ideation2.532f062c.jpg";